export default function GetYear() {
  return new Date().getFullYear();
}
